(() => {

    /* =========================================================
    BXGY RULES (JS)
    ========================================================= */

    const BXGY_RULES = [
        {
            id: 'sub-x',
            trigger: {
                productIds: [10118838091960],
                requireSubscription: true
            },
            reward: {
                variantId: 52246972039352,
                maxQty: 1,
                qtyMode: 'fixed'
            }
        },
        /*
        {
            id: 'sub-or-onetime-x',
            trigger: {
                productIds: [10187059757240],
                requireSubscription: false
            },
            reward: {
                variantId: 52863352078520,
                maxQty: 100,
                qtyMode: 'match_trigger'
            }
        }
        */
    ];

    const THRESHOLD_RULE = window.THRESHOLD_GIFT_CONFIG || {
        enabled: false,
        limit: 0,
        variants: []
    };

    let isSyncing = false;

    /* =========================================================
    CSS — hide qty selector for gifts
    ========================================================= */

    (function() {

        if (document.getElementById('free-gift-css')) return;

        const ids = [
            ...BXGY_RULES.map(r => r.reward.variantId),
            ...(THRESHOLD_RULE.variants || [])
        ];

        const style = document.createElement('style');
        style.id = 'free-gift-css';

        style.textContent = ids.map(id => `
            .cart--item[data-variant-id="${id}"] .quantity-selector,
            .cart--item[data-variant-id="${id}"] .cart--item--quantity{
            display:none !important;
            }
            `).join('\n');

        document.head.appendChild(style);

    })();

    /* =========================================================
    HELPERS
    ========================================================= */

    async function getCart() {
        const res = await fetch('/cart.js');
        return res.json();
    }

    function isGiftVariant(id) {

        return (
            BXGY_RULES.some(r => r.reward.variantId == id) ||
            THRESHOLD_RULE.variants.includes(Number(id))
        );

    }

    function getTriggerQty(rule, cart) {

        const mode = rule.trigger.requireSubscription;

        return cart.items
            .filter(item => {

                if (isGiftVariant(item.variant_id)) return false;

                if (!rule.trigger.productIds.includes(item.product_id)) return false;

                if (mode === true) return !!item.selling_plan_allocation;

                if (mode === 'only_onetime') return !item.selling_plan_allocation;

                return true;

            })
            .reduce((sum, item) => sum + item.quantity, 0);

    }

    function ruleMatches(rule, cart) {

        const triggerItems = cart.items.filter(item => {

            if (isGiftVariant(item.variant_id)) return false;

            return rule.trigger.productIds.includes(item.product_id);

        });

        if (!triggerItems.length) return false;

        const mode = rule.trigger.requireSubscription;

        if (mode === true)
            return triggerItems.some(i => i.selling_plan_allocation);

        if (mode === 'only_onetime')
            return triggerItems.some(i => !i.selling_plan_allocation);

        return true;

    }

    /* =========================================================
    CORE ENGINE
    ========================================================= */

    async function syncGifts() {

        if (isSyncing) return;
        isSyncing = true;
        const checkoutBtn = document.querySelector('.cart--checkout-button');
        try {

            if(checkoutBtn) {
                checkoutBtn.setAttribute('disabled', 'disabled');
            }
            

            const cart = await getCart();
            if (!cart.items) return;

            const desiredGifts = {};

            /* ---------- THRESHOLD GIFTS ---------- */

            if (THRESHOLD_RULE.enabled) {

                const giftTotal = cart.items
                    .filter(item => THRESHOLD_RULE.variants.includes(item.variant_id))
                    .reduce((sum, item) => sum + item.line_price, 0);

                const qualifies = (cart.total_price - giftTotal) >= THRESHOLD_RULE.limit;

                THRESHOLD_RULE.variants.forEach(id => {

                    desiredGifts[id] = Math.max(
                        desiredGifts[id] || 0,
                        qualifies ? 1 : 0
                    );

                });

            }

            /* ---------- BXGY RULES ---------- */

            for (const rule of BXGY_RULES) {

                const triggerQty = getTriggerQty(rule, cart);
                const matched = ruleMatches(rule, cart);

                let desiredQty = 0;

                if (matched) {

                    if (rule.reward.qtyMode === 'match_trigger')
                        desiredQty = Math.min(triggerQty, rule.reward.maxQty);

                    else
                        desiredQty = rule.reward.maxQty;

                }

                desiredGifts[rule.reward.variantId] = Math.max(
                    desiredGifts[rule.reward.variantId] || 0,
                    desiredQty
                );

            }

            /* =========================================================
            BUILD FAST UPDATE
            ========================================================= */

            const updates = {};

            for (const variantId in desiredGifts) {

                const desiredQty = desiredGifts[variantId];

                const item = cart.items.find(
                    i => i.variant_id == variantId
                );

                if (item) {

                    if (item.quantity !== desiredQty) {
                        updates[variantId] = desiredQty;
                    }

                } else if (desiredQty > 0) {

                    updates[variantId] = desiredQty;

                }

            }

            /* =========================================================
            APPLY UPDATE
            ========================================================= */

            const CartClass = customElements.get('cart-element');

            if(Object.keys(updates).length){

              if(CartClass){

                const res = await fetch(`${Shopify.routes.cart_update}.js`,{
                  method:'POST',
                  headers:{'Content-Type':'application/json'},
                  body:JSON.stringify({
                    updates,
                    sections: CartClass.sections
                  })
                });

                const { items, item_count, sections } = await res.json();

                CartClass.fillBasket(items);
                CartClass.updateTotals(item_count);
                CartClass.updateAllHtml(sections);

              } else {

                await fetch('/cart/update.js',{
                  method:'POST',
                  headers:{'Content-Type':'application/json'},
                  body:JSON.stringify({updates})
                });

              }

            }

        } catch (err) {
            console.error('Gift engine error', err);
        } finally {
            isSyncing = false;
            if(checkoutBtn) {
                checkoutBtn.removeAttribute('disabled');
            }
        }

    }

    /* =========================================================
    DEBOUNCE EVENTS
    ========================================================= */

    let syncTimer;

    function triggerSync() {
        clearTimeout(syncTimer);
        syncTimer = setTimeout(syncGifts, 120);
    }

    window.addEventListener('theme:cart:updated', triggerSync);
    window.addEventListener('theme:cart:productAdded', triggerSync);

    /* =========================================================
    INITIAL RUN
    ========================================================= */

    syncGifts();

    console.log('⚡ Fast BXGY + Threshold gift engine loaded');

})();